import type { CanvasTarget } from '../types';
import { pageTarget } from './format';

export interface SuggestionPointer {
  id: string;
  pageId: string | null;
}

/**
 * The transcript keeps only an immutable pointer to a suggestion.
 * suggest_page_edits answers with `suggestion`; earlier chats keep
 * propose_knowledge_change's `proposal`.
 */
export function suggestionPointer(output: unknown): SuggestionPointer | null {
  if (!output || typeof output !== 'object') return null;
  const record = output as Record<string, unknown>;
  const item = (record.suggestion ?? record.proposal) as Record<string, unknown> | undefined;
  if (!item || typeof item !== 'object' || typeof item.id !== 'string' || !item.id) return null;
  return {
    id: item.id,
    pageId: typeof item.pageId === 'string' && item.pageId ? item.pageId : null,
  };
}

/**
 * Where a suggestion made in chat is reviewed: its page with the suggestion in
 * focus, or (a suggested new page, whose page does not exist yet) the
 * suggestion link that resolves to its parent.
 */
export function suggestionCanvas(output: unknown): CanvasTarget | null {
  const pointer = suggestionPointer(output);
  if (!pointer) return null;
  return pointer.pageId
    ? pageTarget({ id: pointer.pageId, suggestion: pointer.id })
    : { kind: 'page-proposal', id: pointer.id };
}
